import {AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {Trans, useTranslation} from '@/translations/i18n'
import {StyledActivityReportWarningBanner} from './style'

type ActivityReportValidationBannerProps = {
    accessesToValidate: number
    absencesToValidate: number
}

export const ActivityReportValidationBanner = ({
    accessesToValidate,
    absencesToValidate
}: ActivityReportValidationBannerProps) => {
    const {t} = useTranslation()

    const hasAccesses = accessesToValidate > 0
    const hasAbsences = absencesToValidate > 0
    const i18nKey =
        hasAccesses && hasAbsences
            ? 'activity_report:validation_banner_description_both'
            : hasAbsences
              ? 'activity_report:validation_banner_description_absences'
              : 'activity_report:validation_banner_description_accesses'

    return (
        <StyledActivityReportWarningBanner>
            <div className="banner-header">
                <AlertTriangleIcon size={16} />
                {t('activity_report:validation_banner_title')}
            </div>
            <span>
                <Trans
                    i18nKey={i18nKey}
                    components={{b: <b />, br: <br />}}
                    values={{accesses: accessesToValidate, absences: absencesToValidate}}
                />
            </span>
        </StyledActivityReportWarningBanner>
    )
}
